<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8.199" height="14.85" viewBox="0 0 8.199 14.85">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_2252" data-name="Rectangle 2252" width="8.199" height="14.85" transform="translate(0 0)" fill="none"/>
    </clipPath>
  </defs>
  <g id="arrow_right" data-name="arrow right" transform="translate(0 0)">
    <g id="Groupe_3953" data-name="Groupe 3953" clip-path="url(#clip-path)">
      <path id="Tracé_1416" data-name="Tracé 1416" d="M7.879,6.614,1.938.356A1.1,1.1,0,0,0,1.129,0H1.123a1.112,1.112,0,0,0-.8.347,1.192,1.192,0,0,0,0,1.619L5.494,7.421.319,12.881a1.183,1.183,0,0,0-.014,1.6l.081.084A1.1,1.1,0,0,0,1.932,14.5L7.883,8.233a1.189,1.189,0,0,0,0-1.619" fill="#3c3c3b"/>
    </g>
  </g>
</svg>
